"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAuthHeader = exports.CSRF_TOKEN_KEY = exports.REFRESH_TOKEN_EXPIRY_KEY = exports.ACCESS_TOKEN_EXPIRY_KEY = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var isProductionUrl_1 = __importDefault(require("./utils/isProductionUrl"));
function getURL(baseURL, pathname) {
    if (!baseURL) {
        throw new Error('baseURL is not defined. Set it by using Session.setBaseUrl(yourBaseUrl)');
    }
    return new URL(pathname, new URL(baseURL)).toString();
}
exports.ACCESS_TOKEN_EXPIRY_KEY = '_fat.expiry';
exports.REFRESH_TOKEN_EXPIRY_KEY = '_frt.expiry';
exports.CSRF_TOKEN_KEY = '_fct';
exports.newAuthHeader = {
    'auth-version': 'v2',
};
var stagingSuffix = '.staging';
var SessionService = /** @class */ (function () {
    function SessionService() {
    }
    SessionService.prototype.setBaseUrl = function (baseURL, shouldSetEnvironment) {
        if (shouldSetEnvironment === void 0) { shouldSetEnvironment = true; }
        SessionService.baseURL = baseURL;
        if (shouldSetEnvironment) {
            SessionService.isProduction = (0, isProductionUrl_1.default)(baseURL);
        }
    };
    Object.defineProperty(SessionService.prototype, "isAuthenticated", {
        get: function () {
            return SessionService.refreshTokenIsValid();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "isProduction", {
        get: function () {
            return SessionService.isProduction;
        },
        enumerable: false,
        configurable: true
    });
    SessionService.formatEnvCookieName = function (value) {
        if (Session.isProduction) {
            return value;
        }
        return "".concat(value).concat(stagingSuffix);
    };
    SessionService.prototype.fetchCsrfToken = function (isRefetch) {
        if (isRefetch === void 0) { isRefetch = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, csrfToken, error, responseStatus;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        SessionService.csrfTokenPromise = new Promise(function (resolve, reject) {
                            try {
                                var csrfResponse = fetch(getURL(SessionService.baseURL, '/csrf'), {
                                    method: 'POST',
                                    headers: exports.newAuthHeader,
                                    credentials: 'include',
                                });
                                csrfResponse
                                    .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                    var resp;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, response.json()];
                                            case 1:
                                                resp = _a.sent();
                                                resolve(__assign({ responseStatus: response.status }, resp));
                                                return [2 /*return*/];
                                        }
                                    });
                                }); })
                                    .catch(function (error) {
                                    reject(error);
                                });
                            }
                            catch (e) {
                                reject(e);
                            }
                        });
                        return [4 /*yield*/, SessionService.csrfTokenPromise];
                    case 1:
                        _a = _b.sent(), csrfToken = _a.csrfToken, error = _a.error, responseStatus = _a.responseStatus;
                        SessionService.csrfTokenPromise = undefined;
                        if ([200, 201].includes(responseStatus)) {
                            SessionService.csrfToken = csrfToken;
                            return [2 /*return*/, csrfToken];
                        }
                        throw new Error(error);
                }
            });
        });
    };
    SessionService.getAccessTokenSilently = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.csrfTokenPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.csrfTokenPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.csrfToken) return [3 /*break*/, 4];
                        if (!this.refreshTokenPromise) {
                            this.refreshTokenPromise = fetch(getURL(SessionService.baseURL, '/account/refresh'), {
                                method: 'POST',
                                credentials: 'include',
                                headers: __assign(__assign({}, exports.newAuthHeader), { 'csrf-token': this.csrfToken }),
                            });
                        }
                        return [4 /*yield*/, this.refreshTokenPromise];
                    case 3:
                        resp = _a.sent();
                        this.refreshTokenPromise = undefined;
                        return [2 /*return*/, resp];
                    case 4: throw new Error('No CSRF token for token refresh');
                }
            });
        });
    };
    Object.defineProperty(SessionService, "csrfToken", {
        get: function () {
            var _a;
            return (_a = js_cookie_1.default.get(exports.CSRF_TOKEN_KEY)) !== null && _a !== void 0 ? _a : null;
        },
        set: function (token) {
            if (token) {
                js_cookie_1.default.set(exports.CSRF_TOKEN_KEY, token);
            }
        },
        enumerable: false,
        configurable: true
    });
    SessionService.accessTokenNeedsRefresh = function () {
        var accessTokenExpiryCookie = js_cookie_1.default.get(SessionService.formatEnvCookieName(exports.ACCESS_TOKEN_EXPIRY_KEY));
        if (!accessTokenExpiryCookie) {
            return false;
        }
        var accessTokenExpiresAt = new Date(accessTokenExpiryCookie || 0).getTime();
        var now = new Date().getTime();
        // has not expired
        return accessTokenExpiresAt < now;
    };
    SessionService.refreshTokenIsValid = function () {
        var cookieName = SessionService.formatEnvCookieName(exports.REFRESH_TOKEN_EXPIRY_KEY);
        var cookieExpiresAt = new Date(js_cookie_1.default.get(cookieName) || 0).getTime();
        var now = new Date().getTime();
        // has not expired
        return cookieExpiresAt > now;
    };
    SessionService.prototype.addAxiosInterceptors = function (axiosInstance, onAccountRefreshError, onRequestError, logger) {
        var _this = this;
        var isFetchingCsrfToken = false;
        axiosInstance.interceptors.request.use(function (config) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(SessionService.accessTokenNeedsRefresh() &&
                            SessionService.refreshTokenIsValid())) return [3 /*break*/, 9];
                        response = void 0;
                        if (!SessionService.refreshTokenPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, SessionService.refreshTokenPromise];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 8];
                    case 2:
                        if (!SessionService.csrfTokenPromise) return [3 /*break*/, 4];
                        return [4 /*yield*/, SessionService.csrfTokenPromise];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!!this.csrfToken) return [3 /*break*/, 6];
                        isFetchingCsrfToken = true;
                        logger === null || logger === void 0 ? void 0 : logger('CSRF Token not present: Fetching CSRF token');
                        return [4 /*yield*/, this.fetchCsrfToken()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [4 /*yield*/, SessionService.getAccessTokenSilently()];
                    case 7:
                        response = _a.sent();
                        _a.label = 8;
                    case 8:
                        if (!(response === null || response === void 0 ? void 0 : response.ok)) {
                            onAccountRefreshError === null || onAccountRefreshError === void 0 ? void 0 : onAccountRefreshError(response);
                        }
                        _a.label = 9;
                    case 9: return [2 /*return*/, config];
                }
            });
        }); }, onAccountRefreshError);
        axiosInstance.interceptors.response.use(function (response) {
            if (isFetchingCsrfToken) {
                isFetchingCsrfToken = false;
                logger === null || logger === void 0 ? void 0 : logger('Request proceeded after CSRF Token fetched successfully');
            }
            return response;
        }, function (error) {
            onRequestError === null || onRequestError === void 0 ? void 0 : onRequestError(error);
            return Promise.reject(error);
        });
    };
    SessionService.isProduction = true;
    return SessionService;
}());
var Session = new SessionService();
exports.default = Session;
